import { SyncStrategyRegistry } from "./registry.js";
export class SyncEngine {
    #client;
    #ledger;
    #now;
    #registry;
    #active = new Set();
    constructor(options) {
        this.#client = options.client;
        this.#ledger = options.ledger;
        this.#now = options.now ?? (() => new Date().toISOString());
        this.#registry = options.registry;
    }
    startDomain(domain) {
        this.#registry.require(domain);
        this.#active.add(domain);
    }
    stop(domain) {
        this.#active.delete(domain);
    }
    activeDomains() {
        return [...this.#active].sort();
    }
    async runOnce() {
        return await Promise.all(this.activeDomains().map(async (domain) => await this.#runDomain(domain)));
    }
    async #runDomain(domain) {
        let cursor = (await this.#ledger.read(domain))?.cursor;
        let applied = 0;
        const strategy = this.#registry.require(domain);
        try {
            const request = cursor === undefined ? { domain } : { cursor, domain };
            for await (const rawDelta of this.#client.deltas({ ...request })) {
                const delta = rawDelta;
                const result = await strategy.applyDelta(delta, { domain, now: this.#now() });
                if (result.applied)
                    applied += 1;
                cursor = delta.cursor;
                await this.#ledger.setCursor({ cursor, domain });
            }
            return { applied, cursor, domain, status: "completed" };
        }
        catch (error) {
            return {
                applied: 0,
                cursor,
                domain,
                error: error instanceof Error ? error.message : "Sync domain failed",
                status: "failed",
            };
        }
    }
}
//# sourceMappingURL=sync-engine.js.map